import { useQueryClient } from 'react-query'

export interface VideoSkeletonItem {
  kind: ['widget', 'video', 'skeleton-video-parameters']
  adSkipTimeDurationInSeconds: number
  videoTypeThresholdInSeconds: number
  adMidrollThresholdInSeconds: number
  adMidrollOffsetInPercent: number
}

export type VideoSkeleton = [VideoSkeletonItem]

export type UseVideoSkeleton = () => Omit<VideoSkeletonItem, 'kind'>

const useVideoSkeleton: UseVideoSkeleton = () => {
  const queryClient = useQueryClient()

  const videoSkeleton = queryClient.getQueryData<VideoSkeleton>(
    'videoSkeleton'
  ) as VideoSkeleton

  const { kind, ...restOfProps } = videoSkeleton?.[0] || {}

  return restOfProps
}

export default useVideoSkeleton
